import React, { useEffect } from "react"
import HeroSlider, { Slide, OverlayContainer } from "hero-slider"
import Restaurant from "../../images/hero/Restaurant2.jpg"
import RestaurantThree from "../../images/hero/Restaurant3.jpg"
import Boba from "../../images/hero/boba.jpg"
import Logo from "../../images/brandLogos/masterLogo.png"
import HeroNav from "./HeroNav"
import SocialMedia from "../SocialMedia"

const images = [Boba, Restaurant, RestaurantThree]

const heroSlideLabels = [
  "Sit Lo Saigon boba drinks",
  "Sit Lo Saigon restaurant exterior",
  "Sit Lo Saigon restaurant interior",
]

const Hero = () => {
  useEffect(() => {
    document.querySelectorAll(".slide-background-loader").forEach(img => {
      img.setAttribute("alt", "")
      img.setAttribute("role", "presentation")
      img.setAttribute("aria-hidden", "true")
    })
  }, [])

  return (
    <div
      role="region"
      aria-label="Image slideshow"
      aria-roledescription="carousel"
    >
      <HeroSlider
        slidingAnimation="top_to_bottom"
        orientation="vertical"
        initialSlide={1}
        style={{
          background: "#222",
        }}
        settings={{
          slidingDuration: 400,
          slidingDelay: 100,
          shouldAutoplay: true,
          shouldDisplayButtons: false,
          autoplayDuration: 8000,
          height: "100vh",
        }}
      >
        <OverlayContainer>
          <SocialMedia />
          <section className="hero" aria-label="Welcome to Sit Lo Saigon">
            <img
              className="hero-logo"
              src={Logo}
              alt="Sit Lo Saigon Restaurant brand mark"
              role="presentation"
            />
            <HeroNav />
          </section>
        </OverlayContainer>
        {images.map((image, index) => (
          <div
            key={index}
            role="group"
            aria-roledescription="slide"
            aria-label={
              heroSlideLabels[index] || `Restaurant showcase image ${index + 1}`
            }
          >
            <Slide
              background={{
                backgroundImage: image,
              }}
            ></Slide>
          </div>
        ))}
      </HeroSlider>
    </div>
  )
}

export default Hero
